import { useState } from 'react'
import { useAuth } from '@dss/auth'
import { Banner, Button } from '@dss/design-system'

export function KeycloakLoginButton() {
  const { login, isLoading } = useAuth()
  const [submitting, setSubmitting] = useState(false)
  const [failed, setFailed] = useState(false)
  const startLogin = async () => {
    if (submitting || isLoading) return
    setSubmitting(true)
    setFailed(false)
    try {
      await login()
    } catch {
      setFailed(true)
      setSubmitting(false)
    }
  }
  return <>
    {failed && <Banner variant="danger"
      body="Не удалось открыть страницу входа. Попробуйте ещё раз или обратитесь к пригласившему вас сотруднику." />}
    <Button type="button" variant="primary" fullWidth loading={submitting || isLoading}
      disabled={submitting || isLoading} onClick={() => void startLogin()}>
      Перейти ко входу
    </Button>
  </>
}
